import { IdentityVerificationPayload } from 'api/services/verificationService'
import { IdentityVerificationStatus } from 'types/workflowStatus'

export type SecurityVerificationMode = 'owner-initial' | 'owner-subsequent' | 'tenant'

export type SecurityVerificationFiles = {
  leaseAgreement?: string[]
  personalId?: string[]
  selfieWithId?: string[]
  proofOfIncome?: string[]
}

export function resolveOwnerVerificationMode(
  verification: IdentityVerificationPayload | undefined
): SecurityVerificationMode {
  return needsOwnerPersonalDocs(verification) ? 'owner-initial' : 'owner-subsequent'
}

export function needsOwnerPersonalDocs(
  verification: IdentityVerificationPayload | undefined
): boolean {
  const status: IdentityVerificationStatus = verification?.status ?? 'profile_incomplete'
  if (status === 'identity_approved') return false
  if (status === 'identity_in_review' || status === 'identity_correction_requested') {
    return false
  }
  return true
}

export function isIdentityApproved(
  verification: IdentityVerificationPayload | undefined
): boolean {
  return verification?.status === 'identity_approved'
}

export function canProceedAfterTenantVerification(
  verification: IdentityVerificationPayload | undefined
): boolean {
  return verification?.status === 'identity_approved'
}
